import { yup, parsePhoneNumber } from "./imports";

export const forgotPasswordWithEmailSchema = () => {
  return yup.object({
    email: yup
      .string()
      .email("Please enter a valid email address")
      .required("Please enter your email"),
  });
};

export const forgotPasswordWithMobileSchema = (selectedCountryCode: Ref<string>) => {
  return yup.object({
    mobile: yup
      .string()
      .required("Please enter your mobile number")
      .test("is-valid-mobile", "Invalid phone number", function (value) {
        const fullNumber = `${selectedCountryCode.value}${value}`;
        return parsePhoneNumber(fullNumber)?.isValid() || false;
      }),
  });
};
